module.exports = __webpack_public_path__ + "static/img/offer.09df8e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/specialist/offer.png
// module id = 1Ppt
// module chunks = 1